import { lazy } from 'react'

export const Cooking = lazy(() => import('./Cooking'))
